import generateUtilityClasses from '@mui/material/generateUtilityClasses';

export const chipSelectionClasses = generateUtilityClasses('AFChipSelection', [
  'labelContainer',
  'labelName',
  'labelValueContainer',
  'labelValue',
  'helpTooltip',
  'labelTooltip',
  'startAdornment',
  'endAdornment'
]);
